<template>
  <div class="enterprise-content">
    <p>Filter</p>
    <el-row :gutter="20" class="provinceBox">
      <el-col :span="3">
        <div class="text-label">province</div>
      </el-col>
      <el-col :span="20">
        <ul class="province clearBoth">
          <li :class="-1 === selectedRegion ? 'on' : ''" @click="selectedProvince('', -1)">All</li>
          <li v-for="(item, index) in $parent.$parent.$parent.$parent.paramForm.enterprise.region"
              v-if="index < provinceMax" :key="index"
              :class="index === selectedRegion ? 'on' : ''" @click="selectedProvince(item, index)">{{ item }}
          </li>
          <li v-if="$parent.$parent.$parent.$parent.paramForm.enterprise.region" class="show" @click="showAll">
            <i :class="provinceMax < $parent.$parent.$parent.$parent.paramForm.enterprise.region.length ? 'el-icon-caret-bottom' : 'el-icon-caret-top'">
              {{
                provinceMax < $parent.$parent.$parent.$parent.paramForm.enterprise.region.length ? 'unfurl' : 'Pack up'
              }}
            </i>
          </li>
        </ul>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="industry">
      <el-col :span="3">
        <div class="text-label">industry</div>
      </el-col>
      <el-col :span="8">
        <el-select v-model="selectedIndustry" filterable placeholder="Please enter the industry you want to add"
                   size="mini" class="industrySelect">
          <el-option v-for="i in $parent.$parent.$parent.$parent.paramForm.enterprise.industries" :key="i" :label="i"
                     :value="i"/>
        </el-select>
        <el-button class="industryPlus" icon="el-icon-plus icon-plus" size="mini" type="primary"
                   @click="handleInputConfirm"></el-button>
      </el-col>
      <el-col :span="12">
        <el-tag v-for="tag in $parent.$parent.$parent.$parent.data.enterprise.industries" :key="tag"
                :disable-transitions="false" closable @close="handleClose(tag)">
          {{ tag }}
        </el-tag>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: "manuscriptSearch",
  data() {
    return {
      selectedIndustry: '',
      selectedRegion: -1,
      provinceMax: 15
    }
  },
  methods: {
    showAll() {
      if (this.provinceMax < this.$parent.$parent.$parent.$parent.paramForm.enterprise.region.length) {
        this.provinceMax = this.$parent.$parent.$parent.$parent.paramForm.enterprise.region.length;
      } else {
        this.provinceMax = 15;
      }
    },
    selectedProvince(item, index) {
      this.$parent.$parent.$parent.$parent.data.enterprise.region = item
      this.selectedRegion = index
    },
    handleClose(tag) {
      this.$parent.$parent.$parent.$parent.data.enterprise.industries.splice(this.$parent.$parent.$parent.$parent.data.enterprise.industries.indexOf(tag), 1)
    },
    handleInputConfirm() {
      if (this.selectedIndustry) {
        if (this.$parent.$parent.$parent.$parent.data.enterprise.industries.indexOf(this.selectedIndustry) < 0) {
          this.$parent.$parent.$parent.$parent.data.enterprise.industries.push(this.selectedIndustry)
          this.selectedIndustry = ''
        } else {
          this.$message.warning('The industry already exists')
        }
      } else {
        this.$message.warning('Please select industry')
      }
    }
  }
}
</script>

<style scoped>
.enterprise-content {
  text-align: left;
}

.enterprise-content p {
  font-weight: bold;
  color: #2f8eff;
  text-align: left;
  padding-bottom: 20px;
  border-bottom: 1px solid #d8d8d8;
  margin-bottom: 20px;
}

.enterprise-content .text-label {
  font-size: 14px;
  color: #333333;
  font-family: "微软雅黑 Regular", 微软雅黑;
  font-weight: 400;
  font-style: normal;
  text-align: left;
  line-height: 28px;
  margin-right: 40px;
}

.enterprise-content .province {
  line-height: 28px;
}

.enterprise-content .province li {
  float: left;
  font-size: 12px;
  cursor: pointer;
  margin-right: 20px;
}

.enterprise-content .province .show {
  color: #2f8eff;
  font-size: 12px;
  cursor: pointer;
}

.enterprise-content .provinceBox {
  margin-bottom: 20px;
}

.enterprise-content .el-input {
  width: 80%;
  margin-right: 10px;
}

.enterprise-content .icon-plus {
  font-weight: bold;
}

.enterprise-content .industry .el-tag {
  margin-right: 10px;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  color: #7F7F7F;
  height: 28px;
  line-height: 26px;
  border-radius: 12px;
  margin-bottom: 6px;
}

.on {
  color: #2f8eff;
}

.industrySelect {
  width: 300px;
}

.industryPlus {
  margin-left: 10px;
}
</style>
